export type ApiResponse<T> = {
  jsonrpc: string
  result: T
}

export type Country = {
  id: number
  display_name: string
}

export type User = {
  uid: string
  name: string
  api_user_name: string
  username: string
  gender: 'male' | 'female'
  halaqat_role: UserRole
  bayen_role: UserRole
  partner_display_name: string
  user_branches: {
    current_branch_id: number
    current_branch_name: string
    allowed_branches: [number, string][]
  }
}

export enum UserRole {
  TEACHER = 'TEACHER',
  ADMIN = 'ADMIN',
  STUDENT = 'STUDENT'
}
export type Branch = {
  id: number
  display_name: string
}

export type Mosque = {
  id: number
  display_name: string
}

export type QuranSection = {
  id: number
  display_name: string
}

export type QuranSectionLine = {
  id: number
  display_name: string
}

export type Student = {
  id: number
  name: string
  todayEvaluation: any
  preEvaluation: any
  evaluations: any[]
  nationality_id: {
    id: number
    name: string
  }
  civil_registry: string
  date_of_birth: string
  education_type: string
  completed_noorani_qaida_study: boolean
  educational_stage: string
  company_branch_id: {
    id: number
    name: string
  }
  mosque_id: {
    id: number
    name: string
  }
  student_parent: boolean
  student_parent_mobile: boolean
  address: string
  previous_memorization: number
  mobile: string
  last_memorization: string | boolean
  email: string | false
  ensure_days: number
  student_strengths: boolean
  general_notes: boolean
  student_session_id: {
    id: number
    name: string
  }
  date_start_plan: string | boolean
  date_end_plan: string | boolean
  daily_recitation_plan_id: {
    id: number
    name: string
  }
  recitation_start_id: {
    id: number
    name: string
  }
  daily_revision_plan_id: {
    id: number
    name: string
  }
  revision_start_id: {
    id: number
    name: string
  }
  create_date: string
  current_plan_id: Entity
  last_memorization_surah_number: number
  last_memorization_verses: number

  mobile_whatsapp_verification: boolean
}

export type Session = {
  id: number
  name: string
  company_branch_id: {
    id: number
    name: string
  }
  mosque_id: {
    id: number
    name: string
  }
  period: string

  teacher_id: {
    id: number
    name: string
  }
  specified_time: boolean
  session_time_from: number
  session_time_to: number
  specialist_teacher_id: boolean
  daily_evaluation_sections: string
  request_type_id: {
    id: number
    name: string
  }
  day_ids: Array<{
    id: number
    name: string
    weekday: number
  }>
  student_ids: Array<{
    id: number
    name: string
  }>
  create_date: string
}

export interface Evaluation extends Object {
  id: number
  session_id: Session
  student_id: Student
  daily_evaluation_sections: string
  presence_type: 'present' | 'absent' | 'late' | 'excused'
  hearing_not_done: boolean
  absence_reason: boolean | string
  late_reason: boolean | string
  late_duration: number
  register_infraction: boolean
  infraction: boolean
  final_degree: boolean | number
  date: string
  stage_id: boolean | number
  character_exits: boolean
  revelation: boolean | number
  intonation: boolean | number
  teacher_notes: boolean | string
  parent_notes: boolean | string
  request_type_id: boolean | number
  gender: boolean | string
  verse_memorize_from: number
  verse_memorize_to: number
  total_memorize_line: number
  total_memorize_page: number
  memorize_school_error_ids: number[]
  surah_review_from_id: {
    name: string
    id: number
  }
  verse_review_from: number
  surah_review_to_id: {
    name: string
    id: number
  }
  verse_review_to: number
  total_review_line: number
  total_review_page: number
  review_school_error_ids: number[]
  surah_ensure_from_id: {
    name: string
    id: number
  }
  surah_ensure_to_id: {
    name: string
    id: number
  }
  surah_memorize_from_id: {
    name: string
    id: number
  }
  surah_memorize_to_id: {
    name: string
    id: number
  }
  verse_ensure_from: number
  verse_ensure_to: number
  total_ensure_line: number
  total_ensure_page: number
  ensure_school_error_ids: number[]
  surah_recitation_from_id: {
    name: string
    id: number
  }
  verse_recitation_from: number
  surah_recitation_to_id: {
    name: string
    id: number
  }
  verse_recitation_to: number
  total_recitation_line: number
  total_recitation_page: number
  recitation_school_error_ids: number[]
  create_date: string
  degree_memorize: string | false
  degree_review: string | false
  degree_ensure: string | false
}

export type Surah = {
  name: string
  id: number
  surah_number: number
}

export type PlanLine = {
  id: number
  surah_from_id: Surah
  verse_from: number
  surah_to_id: Surah
  verse_to: number
  date: string
  old_date: false | string
  evaluation_id: false | number
}

export type Entity = {
  id: number
  name: string
}

export type Plan = {
  id: number
  student_id: Entity
  date_start: string
  company_branch_id: Entity
  mosque_id: Entity
  memorize_plan_line_ids: PlanLine[]
  revue_plan_line_ids: PlanLine[]
}

export type Absence = {
  id: number
  student_id: Entity
  date: string
  reason: string
  absence_type: false | string
  date_start_absence: string
  company_branch_id: Entity
  mosque_id: Entity
  state: 'draft' | 'done'
}

export type Library = {
  id: number
  name: string
}

export type Book = {
  id: number
  name: string
  temp_author: string
  public_number: string | false
  library_id: Library
  book_place_number: string
  book_place_code: string
  book_location: string | false
}

export type BooksResponse = {
  number_of_records: number
  records: Book[] | Record<string, Book[]>[]
}

export type BooksParams = {
  filter?: (string | [string, string, number | string])[]
  group?: 'temp_author' | 'library_id'
  page: number
  limit: number
  order: 'name' | 'id'
  fields: string[]
}
